// 导入颜色选择器组件
import tree from './tree';
import breadcrumb from './breadcrumb';
import submenu from './submenu';
import dialog from './dialog';
import identify from './identify'; // 病人住院
import list from './list'; // 图片上传
// import transLate from './transLate'; // 树弹出框
// 存储组件列表
const components = {
    tree,
    breadcrumb,
    submenu,
    dialog,
    identify,
    list
    // transLate
};
// 定义 install 方法，接收 Vue 作为参数。如果使用 use 注册插件，则所有的组件都将被注册
const install = function (Vue) {
    // 判断是否安装
    if (install.installed) return;
    // 遍历注册全局组件
    Object.keys(components).map(e => Vue.component('d-' + e, components[e]));
};

// 判断是否是直接引入文件
if (typeof window !== 'undefined' && window.Vue) {
    install(window.Vue);
}

export default {
    // 导出的对象必须具有 install，才能被 Vue.use() 方法安装
    install
};
